import { create } from "zustand";
interface State {
  language: string;
  setLanguage: (language: string) => void;
}
export const useStore = create<State>(set => ({
  language: "en",
  setLanguage: (language: string) => set({
    language
  })
}));